import '../App.css';
import React, { useCallback, useRef, useEffect, useState } from 'react';
import { useComfy } from "../comfy/ComfyProvider";

//Placeholder preview image
import { base } from "../dashboard/image";

//custom components
import PreviewPanel from "./PreviewPanel";
import InputPanel from "./InputPanel";
import PromptingPanel from "./PromptingPanel";
import OutputPanel from "./OutputPanel";
import GalleryPanel from "./GalleryPanel";

// Import MUI Components
import { 
    //Containers
    Box, Stack, SelectChangeEvent ,
    //Message
    Snackbar, Alert ,  
        } from '@mui/material';
import { useDropzone } from "react-dropzone";


//VARIABLES//
const Dashboard: React.FC = () => {
    //Prompt queing
    const { queuePrompt, fetchCheckpoints} = useComfy();
    const [generationMode, setGenerationMode] = useState<boolean>(true);
    const [isGenerating, setIsGenerating] = useState(false);

    //IMage input
    const [synchronization, setSynchronization] = useState("image");
    const videoRef = useRef<HTMLVideoElement>(null);
    const streamRef = useRef<MediaStream | null>(null);
    const [inImage, setInimage] = useState< string >("");

    //Color Prompting
    const [cyanPromptWeight, setCyanPromptWeight] = useState<number>(0.5);
    const [cyanNegativeWeight, setCyanNegativeWeight] = useState<number>(0.5);
    const [cyanImgWeight, setCyanImgWeight] = useState<number>(0.9);
    const [cyanReference, setCyanReference] = useState<string>("");    
    const [cyanPrompt, setCyanPrompt] = useState<string>("");    
    const [cyanNegative, setCyanNegative] = useState<string>("");

    const [bluePromptWeight, setBluePromptWeight] = useState<number>(0.5);
    const [blueNegativeWeight, setBlueNegativeWeight] = useState<number>(0.5);
    const [blueImgWeight, setBlueImgWeight] = useState<number>(0.9);  
    const [blueReference, setBlueReference] = useState< string >("");
    const [bluePrompt, setBluePrompt] = useState<string>("");
    const [blueNegative, setBlueNegative] = useState<string>("");

    const [limePromptWeight, setLimePromptWeight] = useState<number>(0.5);
    const [limeNegativeWeight, setLimeNegativeWeight] = useState<number>(0.5);
    const [limeImgWeight, setLimeImgWeight] = useState<number>(0.9);
    const [limeReference, setLimeReference] = useState< string >("");    
    const [limePrompt, setLimePrompt] = useState<string>("");    
    const [limeNegative, setLimeNegative] = useState<string>("");

    const [greenPromptWeight, setGreenPromptWeight] = useState<number>(0.5);
    const [greenNegativeWeight, setGreenNegativeWeight] = useState<number>(0.5);
    const [greenImgWeight, setGreenImgWeight] = useState<number>(0.9);
    const [greenReference, setGreenReference] = useState< string >("");    
    const [greenPrompt, setGreenPrompt] = useState<string>("");    
    const [greenNegative, setGreenNegative] = useState<string>("");

    const [redPromptWeight, setRedPromptWeight] = useState<number>(0.5);
    const [redNegativeWeight, setRedNegativeWeight] = useState<number>(0.5);
    const [redImgWeight, setRedImgWeight] = useState<number>(0.9);
    const [redReference, setRedReference] = useState< string >("");
    const [redPrompt, setRedPrompt] = useState<string>("");
    const [redNegative, setRedNegative] = useState<string>("");

    const [vegetationPromptWeight, setVegetationPromptWeight] = useState<number>(0.5);
    const [vegetationNegativeWeight, setVegetationNegativeWeight] = useState<number>(0.5);
    const [vegetationImgWeight, setVegetationImgWeight] = useState<number>(0.9);
    const [vegetationReference, setVegetationReference] = useState< string >("");    
    const [vegetationPrompt, setVegetationPrompt] = useState<string>("");    
    const [vegetationNegative, setVegetationNegative] = useState<string>("");

    const [colorState, setColorState] = useState<"required" | "error">("required")

    // calls image to preview
    const [rand, setRand] = useState<number>(Math.random);
    const [image, setImage] = useState<string | null>(null);

    // checks available checkpoints
    const [checkpoints, setCheckpoints] = useState<string[][]>([]);
    const [selectedCheckpoint, setSelectedCheckpoint] = useState<string>("");

    // sets imagination and interation values
    const [cfg, setCfg] = useState(2.5);
    const [steps, setSteps] = useState(8);
    const [cnetEdges, setCnetEdges] = useState(0.3);
    const [cnetVolume, setCnetVolume] = useState(0.2);

    // set new seed values
    const [seed, setSeed] = useState(Math.round(Math.random() * Number.MAX_SAFE_INTEGER));
    const [seedMode, setSeedMode] = useState("random"); 

    // sets the resolution
    const [resolution, setResolution] = useState("SD");
    const [height, setHeight] = useState(512);
    const [width, setWidth] = useState(512);
    const [upscaler, setUpscaler] = useState(false)

    // reads prompting
    const [positivePrompt, setPositivePrompt] = useState("");

    const [atmosphere, setAtmosphere] = useState("day"); 
    const [style, setStyle] = useState("sketch");
    const [season, setSeason] = useState("autumn");


    const [atmospherePrompt, setAtmospherePrompt] = useState("");
    const [stylePrompt, setStylePrompt] = useState("");
    const [seasonPrompt, setSeasonPrompt] = useState("");

    const [negativePrompt, setNegativePrompt] = useState("");



    // calculates the progress
    const [inProgress, setInProgress] = useState(false);
    const [progress, setProgress] = useState(0);

    // checks the queu status
    const [queue, setInQueue] = useState(0);

    //gallery
    const [galleryImages, setGalleryImages] = useState<string[]>([]);


    //  creates message boxes
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    const [sopen, setSOpen] = useState(false);
    const [success, setSuccess] = useState("");

    const [activeSnackbars, setActiveSnackbars] = useState<{ id: number, type: 'error' | 'success' }[]>([]);
    const [messageCount, setMessageCount] = useState(0); 

    // API WebSocket

    const { outputImage, jobStatus, queueStatus, setQueueStatus } = useComfy();

//LOGIC//
    const handleSeedModeChange = (event: React.MouseEvent<HTMLElement>, newMode: string | null) => {
        if (newMode !== null) {
          setSeedMode(newMode);
          if (newMode === "fixed") {
            setSeed(seed);
          } else if (newMode === "random") {
            setSeed(Math.round(Math.random() * Number.MAX_SAFE_INTEGER));
          } else if (newMode === "incremental") {
            setSeed(seed + 1);
          }
        }
      };

      const handleResolutionChange = (_event: React.MouseEvent<HTMLElement>, newResolution: string | null) => {
        if (newResolution !== null) {
            setResolution(newResolution);
            if (newResolution === "HD") {
                setWidth(1024);
                setHeight(1024);
                setUpscaler(true);
            } else {
                setWidth(512);
                setHeight(512);
                setUpscaler(false);
            }
        }
    };

    const [checkedColors, setCheckedColors] = React.useState({
        cyan:       true,
        blue:       true,
        lime:       true,
        green:      true,
        red:        true,
        vegetation: true,
      });
      
      const handleCheckedColors = (color: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedColors((prev) => ({
          ...prev,
          [color]: event.target.checked,
        }));
      };
    
//Prompting Atmosphere and style
        const handleAtmosphereChange = (event: SelectChangeEvent) => {
            setAtmosphere(event.target.value);
        };

        const generateAtmospherePrompt = () => {
            const presetPromptAtmosphere =
            "An architectural visualization set in {{SEASON}}, featuring {{ATMOSPHERE}} The scene conveys a natural and immersive environment, with realistic lighting and atmospheric depth enhancing the overall composition.";

            const atmosphereMap: Record<string, string> = {
                day: "a clear and bright atmosphere with natural sunlight casting soft shadows, a crisp blue sky with a few wispy clouds, and a vibrant, well-lit environment.", // Daylight
                dawn: "a serene early morning atmosphere with soft, golden light, long shadows, and a gentle mist in the air. The sky transitions from deep blue to warm orange and pink hues, creating a peaceful ambiance.", // Dawn
                night: "a quiet nighttime setting with a deep, dark sky and scattered stars. Subtle artificial lighting from nearby structures casts a warm glow, creating contrast between illuminated and shadowed areas. A calm and tranquil mood dominates the scene." // Night
            };

            const selectedAtmosphere = atmosphereMap[atmosphere] || "";

            setAtmospherePrompt(presetPromptAtmosphere.replace("{{ATMOSPHERE}}", selectedAtmosphere).replace("{{SEASON}}", season));
        };

        // Call this function whenever the atmosphere or season changes
        useEffect(() => {
            generateAtmospherePrompt();
        }, [atmosphere, season]);

        const handleSeasonChange = (event: SelectChangeEvent) => {
            setSeason(event.target.value);
        };
        
        // Generates season prompt
        const generateSeasonPrompt = () => {
            const seasonMap: Record<string, string> = {
                spring: "a lively and fresh environment with blooming trees, budding plants, and a soft breeze in the air. The surroundings are filled with vibrant greens and pastel colors, evoking a sense of renewal and energy",
                summer: "a warm and bright setting with lush greenery, clear blue skies, and a strong presence of sunlight. The atmosphere feels dynamic and lively, with long days and a vibrant outdoor presence",
                autumn: "a picturesque scene with golden-hued trees, fallen leaves, and a crisp, cool breeze. The environment is bathed in warm, earthy tones, creating a cozy and nostalgic feeling",
                winter: "a serene and peaceful landscape with snow-covered surroundings, bare trees, and a crisp, cold atmosphere. The air is fresh, and the soft diffused light creates a tranquil, quiet ambiance"
            };

            const selectedSeason = seasonMap[season] || "";
            setSeasonPrompt(selectedSeason);
        };

        useEffect(() => {
            generateSeasonPrompt();
        }, [season]);

        const handleStyleChange = (event: SelectChangeEvent) => {
            setStyle(event.target.value);
        };

        const generateStylePrompt = () => {
            const presetPromptStyle ="{{STYLE}}";

            const styleMap: Record<string, string> = {
                real: "nunu.safetensors",
                picto: "flat_XSArchi_145_SD15.safetensors",
                sketch: "KY_Sketch_SDXL.safetensors",
            };

            const selectedStyle = styleMap[style] || "";

            setStylePrompt(presetPromptStyle.replace("{{STYLE}}", selectedStyle));
        };

        // Call this function whenever the style changes
        useEffect(() => {
            generateStylePrompt();
        }, [style]);

        //updates the positive prompt
        useEffect(() => {
            const stylePromptName = stylePrompt.split(".")[0];
            setPositivePrompt(`${stylePromptName}, ${atmospherePrompt}, ${seasonPrompt}`);
        }, [stylePrompt, atmospherePrompt, seasonPrompt]);


//Dropzone
        const onDrop = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setInimage(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);
        
        const { getRootProps, getInputProps } = useDropzone({
            onDrop,
            accept: { "image/*": [] },
            multiple: false, 
        });

        const onDropCyan = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setCyanReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);

        const onDropBlue = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setBlueReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);

        const onDropLime = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setLimeReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);

        const onDropGreen = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setGreenReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);

        const onDropRed = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setRedReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);

        const onDropVegetation = useCallback((acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];
                const reader = new FileReader();
                reader.onload = () => {
                    setVegetationReference(reader.result as string); 
                };
                reader.readAsDataURL(file); 
            }
        }, []);
        


const handleDelete = () => setInimage("");
const handleDeleteReferenceCyan = () => setCyanReference("");
const handleDeleteReferenceBlue = () => setBlueReference("");
const handleDeleteReferenceLime = () => setLimeReference("");
const handleDeleteReferenceGreen = () => setGreenReference("");
const handleDeleteReferenceRed = () => setRedReference("");
const handleDeleteReferenceVegetation = () => setVegetationReference("");

//Snackbar messages

    const generateSnackbarId = () => Date.now();
    

    const handleErrorClose = (id: number) => {
        setActiveSnackbars(prev => prev.filter(snackbar => snackbar.id !== id)); 
      };
    
      const handleSuccessClose = (id: number) => {
        setActiveSnackbars(prev => prev.filter(snackbar => snackbar.id !== id)); 
      };

useEffect(() => {

        if (jobStatus === "COMPLETED")  {

            setSuccess("Request finished!");
            const id = generateSnackbarId();
            setActiveSnackbars(prev => [...prev, { id, type: 'success' }]);
            setSOpen(true);
        } else if (["FAILED", "TIMED_OUT", "CANCELLED"].includes(jobStatus)) {
            setMessage("Request has either failed or was cancelled, please try again...");
            const id = generateSnackbarId();
            setActiveSnackbars(prev => [...prev, { id, type: "error" }]);
            setOpen(true);
        }

}, [jobStatus]);

// Captures screeshot

function captureFrameFromStream() {
    if (!streamRef.current || !videoRef.current) return;
  
    const video = videoRef.current;
  
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
  
    ctx.drawImage(video, 0, 0);
    const imageData = canvas.toDataURL("image/png");
    setInimage(imageData);
  }
  
        
//Webcam access
useEffect(() => {
    const handleStream = async (getStream: () => Promise<MediaStream>) => {
      try {
        const stream = await getStream();
        streamRef.current = stream;
  
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
  
          // Wait for the video to be ready before capturing
          videoRef.current.onloadedmetadata = () => {
            videoRef.current?.play()
          };
        }
      } catch (error) {
        setMessage("Error accessing stream: ");
        const id = generateSnackbarId();
        setActiveSnackbars(prev => [...prev, { id, type: "error" }]);
        setOpen(true);
      }
    };
  
    if (synchronization === "camera") {
      handleStream(() => navigator.mediaDevices.getUserMedia({ video: true }));
    } else if (synchronization === "viewport") {
      handleStream(() => navigator.mediaDevices.getDisplayMedia({ video: true }));
    } else {
      // Stop any active stream
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    }
  }, [synchronization]);
  

        
        
//checkpoint availability
    useEffect(() => {
        if (checkpoints?.length > 0 && checkpoints[0]?.length > 0) {
          setSelectedCheckpoint(checkpoints[0][0]); // Set the first checkpoint as preselected
        }
    }, [checkpoints]);

    /*function updateCheckpoint() {
        fetchCheckpoints().then(checkpoints => {
            setCheckpoints(checkpoints);
        });
    }*/



async function stopQueue() {

    try {
        /*setSuccess("Stopping any ongoing queue...");
        const id = generateSnackbarId();
        setActiveSnackbars(prev => [...prev, { id, type: "success" }]);
        setSOpen(true);*/

        // Call the stop queue function
        //await stopRunPodQueue();//

        await new Promise((resolve) => setTimeout(resolve, 500));
        generate();
    } catch (error) {
        setMessage("ERROR: Stopping queue...");
        const id = generateSnackbarId();
        setActiveSnackbars(prev => [...prev, { id, type: "error" }]);
        setOpen(true);
    }
    
}


function generate() {


        // If sync mode is "camera" or "viewport", capture a new frame
        if (synchronization === "camera" || synchronization === "viewport") {
            setTimeout(() => {
                captureFrameFromStream();
              }, 200);// This will update inImage state


            /* validation logic

        } else if (!redPrompt || !redReference || !bluePrompt || !blueReference ||!inImage){
              
                setMessage("A prompt and a reference image are required for both colors before generating!");
                const id = generateSnackbarId();
                setActiveSnackbars(prev => [...prev, { id, type: 'error' }]);
                setOpen(true);
                
                setColorState("error")
                return;
                
                */


        }
        /*
         if (selectedCheckpoint === "") {
            setMessage("ERROR: No AI-model was found...");
            const id = generateSnackbarId();
            setActiveSnackbars(prev => [...prev, { id, type: 'error' }]);
            setOpen(true);
            
            setIsGenerating(true);
            
            
            return;
        }
        
        */
    

    
        queuePrompt({
            cfg, steps, cnetEdges, cnetVolume, seed, checkpoint: selectedCheckpoint, height, width,
            positivePrompt, 
            negativePrompt,
             

            cyanReference, 
            cyanPromptWeight,
            cyanNegativeWeight,
            cyanImgWeight,
            cyanPrompt,
            cyanNegative,

            checkedColors,
    
            bluePrompt,
            blueNegative,
            blueReference,
            bluePromptWeight,
            blueNegativeWeight,
            blueImgWeight,

            limeReference, 
            limePromptWeight,
            limeNegativeWeight,
            limeImgWeight,
            limePrompt,
            limeNegative,

            greenReference, 
            greenPromptWeight,
            greenNegativeWeight,
            greenImgWeight,
            greenPrompt,
            greenNegative,    

            redNegative, 
            redPrompt, 
            redReference,
            redPromptWeight,
            redNegativeWeight,
            redImgWeight,

            vegetationReference, 
            vegetationPromptWeight,
            vegetationNegativeWeight,
            vegetationImgWeight,
            vegetationPrompt,
            vegetationNegative,
    

            inImage, 
            atmospherePrompt, 
            stylePrompt,
            style,
            upscaler,

        }).then(res => {
            if (res.prompt_id) {
                setSuccess("Prompt submitted!");
                const id = generateSnackbarId();
                setActiveSnackbars(prev => [...prev, { id, type: 'success' }]);
                setSOpen(true);
                setInProgress(true);
            }
        });
    
        setSeed(prevSeed => (
        seedMode === "random" 
            ? Math.round(Math.random() * Number.MAX_SAFE_INTEGER) 
            : seedMode === "incremental" 
            ? prevSeed + 1 
            : prevSeed
        ));

}
    
    const defineSync = (event: React.MouseEvent<HTMLElement>, newSync: string | null) => {
        if (newSync !== null) {
          setSynchronization(newSync); 
        }
    };

        //add to the gallery
    const addToGallery = () => {
        const selectedImage = outputImage ? outputImage : base;
        
        if (selectedImage) {
            setGalleryImages((prevImages) => [...prevImages, selectedImage]);
            setSuccess("Image added to the gallery!");
            const id = generateSnackbarId();
            setActiveSnackbars(prev => [...prev, { id, type: 'success' }]);
            setSOpen(true);
        }
    };

    const deleteImage = (index: number) => {
        const newImages = [...galleryImages];
        newImages.splice(index, 1); 
        setGalleryImages(newImages); 
        setMessage("Image deleted...");
        const id = generateSnackbarId();
        setActiveSnackbars(prev => [...prev, { id, type: 'error' }]);
        setOpen(true);
        
      };

    const downloadImage = (img: string) => {
        const link = document.createElement('a');
        link.href = img;
        link.download = 'Vizz_imageFromGallery.png'; // Set the default file name
        link.click();
        setSuccess("Image downloaded!");
        const id = generateSnackbarId();
        setActiveSnackbars(prev => [...prev, { id, type: 'success' }]);
        setSOpen(true);
};


//REACT//
    return (
        <div>
            <Stack direction="row" spacing={2} style={{ width: '100%' }}>


{/* Left Panel - Inputs */}
    <Box flex="1" style={{ padding: '0px 20px', width:'33vw', height:'87vh', overflow:"auto"}}>
        
        {/* 0001 Input Panel */}
        <InputPanel
        synchronization={synchronization}
        videoRef={videoRef}
        inImage={inImage}
        handleDelete={handleDelete}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        defineSync={defineSync}
        colorState={colorState}
        />
        {/* 0001 Input Panel */}

        {/* 0002 Prompting Panel */}
        <PromptingPanel

        colorState={colorState}
        atmosphere={atmosphere} 
        handleAtmosphereChange={handleAtmosphereChange}
        season={season}
        handleSeasonChange={handleSeasonChange}
        style={style} 
        handleStyleChange={handleStyleChange}
        setPositivePrompt={setPositivePrompt}
        setNegativePrompt={setNegativePrompt}

        //handleCheckedColors={handleCheckedColors}
        //checkedColors={checkedColors}

        setCyanPrompt={setCyanPrompt}
        cyanPrompt={cyanPrompt}
        setCyanNegative={setCyanNegative}
        cyanNegative={cyanNegative}
        cyanReference={cyanReference}
        onDropCyan={onDropCyan}
        handleDeleteReferenceCyan={handleDeleteReferenceCyan}
        cyanPromptWeight={cyanPromptWeight}
        cyanNegativeWeight={cyanNegativeWeight}
        setCyanPromptWeight={setCyanPromptWeight}
        setCyanNegativeWeight={setCyanNegativeWeight}
        cyanImgWeight={cyanImgWeight}
        setCyanImgWeight={setCyanImgWeight}
        
        setBluePrompt={setBluePrompt}
        bluePrompt={bluePrompt}
        setBlueNegative={setBlueNegative}
        blueNegative={blueNegative}
        blueReference={blueReference}
        onDropBlue={onDropBlue}
        handleDeleteReferenceBlue={handleDeleteReferenceBlue}
        bluePromptWeight={bluePromptWeight}
        blueNegativeWeight={blueNegativeWeight}
        setBluePromptWeight={setBluePromptWeight}
        setBlueNegativeWeight={setBlueNegativeWeight}
        blueImgWeight={blueImgWeight}
        setBlueImgWeight={setBlueImgWeight}

        setLimePrompt={setLimePrompt}
        limePrompt={limePrompt}
        setLimeNegative={setLimeNegative}
        limeNegative={limeNegative}
        limeReference={limeReference}
        onDropLime={onDropLime}
        handleDeleteReferenceLime={handleDeleteReferenceLime}
        limePromptWeight={limePromptWeight}
        limeNegativeWeight={limeNegativeWeight}
        setLimePromptWeight={setLimePromptWeight}
        setLimeNegativeWeight={setLimeNegativeWeight}
        limeImgWeight={limeImgWeight}
        setLimeImgWeight={setLimeImgWeight}

        setGreenPrompt={setGreenPrompt}
        greenPrompt={greenPrompt}
        setGreenNegative={setGreenNegative}
        greenNegative={greenNegative}
        greenReference={greenReference}
        onDropGreen={onDropGreen}
        handleDeleteReferenceGreen={handleDeleteReferenceGreen}
        greenPromptWeight={greenPromptWeight}
        greenNegativeWeight={greenNegativeWeight}
        setGreenPromptWeight={setGreenPromptWeight}
        setGreenNegativeWeight={setGreenNegativeWeight}
        greenImgWeight={greenImgWeight}
        setGreenImgWeight={setGreenImgWeight}

        setRedPrompt={setRedPrompt}
        redPrompt={redPrompt}
        setRedNegative={setRedNegative}
        redNegative={redNegative}
        redReference={redReference}
        onDropRed={onDropRed}
        handleDeleteReferenceRed={handleDeleteReferenceRed}
        redPromptWeight={redPromptWeight}
        setRedPromptWeight={setRedPromptWeight}
        redNegativeWeight={redNegativeWeight}
        setRedNegativeWeight={setRedNegativeWeight}
        redImgWeight={redImgWeight}
        setRedImgWeight={setRedImgWeight}

        setVegetationPrompt={setVegetationPrompt}
        vegetationPrompt={vegetationPrompt}
        setVegetationNegative={setVegetationNegative}
        vegetationNegative={vegetationNegative}
        vegetationReference={vegetationReference}
        onDropVegetation={onDropVegetation}
        handleDeleteReferenceVegetation={handleDeleteReferenceVegetation}
        vegetationPromptWeight={vegetationPromptWeight}
        vegetationNegativeWeight={vegetationNegativeWeight}
        setVegetationPromptWeight={setVegetationPromptWeight}
        setVegetationNegativeWeight={setVegetationNegativeWeight}
        vegetationImgWeight={vegetationImgWeight}
        setVegetationImgWeight={setVegetationImgWeight}
        
        />
        {/* 0002 Prompting Panel */}

        {/* 0003 Output Panel */}
        <OutputPanel
        selectedCheckpoint={selectedCheckpoint}
        setSelectedCheckpoint={setSelectedCheckpoint}
        checkpoints={checkpoints}
        cfg={cfg}
        setCfg={setCfg}
        steps={steps}
        setSteps={setSteps}
        cnetEdges={cnetEdges}
        setCnetEdges={setCnetEdges}
        cnetVolume={cnetVolume}
        setCnetVolume={setCnetVolume}
        seed={seed}
        setSeed={setSeed}
        seedMode={seedMode}
        handleSeedModeChange={handleSeedModeChange}
        resolution={resolution}
        handleResolutionChange={handleResolutionChange}
        generate={generate}
        stopQueue={stopQueue}
        generationMode={generationMode} 
        setGenerationMode={setGenerationMode} 
        isGenerating={isGenerating}
        />
        {/* 0003 Output Panel */}

    </Box>
{/* Left Panel - Inputs */}

{/* Middle Panel - Preview */}


    {/* 0004 Output Panel */}
    <PreviewPanel
    image={image}
    base={base}
    rand={rand}
    inProgress={inProgress}
    progress={progress}
    addToGallery={addToGallery}
    queue={queue}
    />
    {/* 0004 Output Panel */}

{/* Middle Panel - Preview */}


{/* Right Panel - Preview */}
<Box flex='1' style={{ padding: '10px 0px 0px 0px', width: "33vw", height:'87.5vh', overflow:"auto", backgroundColor:""}}>
    
    {/* 0005 Output Panel */}
    <GalleryPanel
        galleryImages={galleryImages}
        deleteImage={deleteImage}
        downloadImage={downloadImage}
        
    />
    {/* 0005 Output Panel */}
                    
</Box>
{/* Right Panel - Preview */}

            </Stack>

{/* Snackbar for Error/Success Messages */}

<Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
      {activeSnackbars.map((snackbar, index) => (
        <Snackbar
          key={snackbar.id}
          open={snackbar.type === 'error' ? open : sopen}
          autoHideDuration={2000}
          onClose={() => snackbar.type === 'error' ? handleErrorClose(snackbar.id) : handleSuccessClose(snackbar.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ mt: `${index * 20}px` }} 
        >
          <Alert severity={snackbar.type}>{snackbar.type === 'error' ? message : success}</Alert>
        </Snackbar>
      ))}
    </Box>

        </div>
    );
};

export default Dashboard;
